import LandingPageToken from '@apps/truevail/admin/tokens/landing_page'
import Clone from '@apps/truevail/admin/views/admin/templates/clone'
import New from '@apps/truevail/admin/views/admin/templates/new'
import TemplateToken from '@apps/truevail/admin/tokens/template'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Landing Pages)',
  collection: {
    endpoint: '/api/admin/truevail/admin/templates/landing_page',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', format: (template) => (
        <TemplateToken template={ template } show_provider={ false } show_voice={ true } />
      ) }
    ],
    empty: {
      icon: 'file-o',
      title: 't(No Landing Pages)',
      text: 't(There are no landing pages for this form)',
      buttons: [
        { 
          label: 't(Create Landing Page)',
          modal: {
            component: <New type="landing_page" form={ props.form } />,
            options: { width: 1168 }
          }
        }
      ]
    },
    defaultQuery: { form_id: props.form.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    entity: 'landing page',
    recordTasks: (record) => [
      {
        label: 't(Duplicate Landing Page)',
        svg: 'copy',
        modal: <Clone form={ props.form } landing_page={ record } /> 
      },
      {
        label: 't(Delete Landing Page)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this landing page?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/templates/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted form)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete form)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/templates/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Landing Page)', 
    modal: {
      component: <New type="landing_page"  form={ props.form } />,
      options: { width: 1168 }
    }
  }
})

export default Panel(null, mapPropsToPanel)
